module.exports = __webpack_public_path__ + "img/G2.b6f27955.svg";